<template>
  <ul class="nav-bar-nav sidebar-nav">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'mainnavigation',
};
</script>
